<template>
  <div class="aspiration-section">
    <span class="accordion-title">
      {{ $t("accordion_aspiration_title") }}
    </span>
    <ListWithArrows
      :entriesLeft="[
        'accordion_aspiration_arrow_list_1',
        'accordion_aspiration_arrow_list_2',
      ]"
      :entriesRight="[
        'accordion_aspiration_arrow_list_3',
        'accordion_aspiration_arrow_list_4',
      ]"
    />
    <AccordionVideoContainer :videoIds="['712880119']" />
    <ScientificInformationCardRow :count="2" prefix="accordion_aspiration" />
    <ProductsForIntervention
      :leftItems="['20402-411', '20402-410', '20402-401', '20402-402']"
      :leftInformation="[
        'accordion_aspiration_products_information_1',
        'accordion_aspiration_products_information_2',
      ]"
      :leftButtonLink="'https://de.erbe-med.com/productfinder/index.php?openurl=PLM_PRODUKTKATEGORIE%3DInstrument%7CPLM_PRODUKTGRUPPE%3DFlexible%20Sonden%7CPLM_PRODUKTUNTERGRUPPE%3DERBECRYO%202&language=en'"
    />
  </div>
</template>

<script>
import ScientificInformationCardRow from "@/components/ScientificInformationCardRow";
import ListWithArrows from "../../components/ListWithArrows.vue";
import ProductsForIntervention from "../../components/ProductsForIntervention.vue";
import AccordionVideoContainer from "../../components/AccordionVideoContainer.vue";

export default {
  name: "AspirationSection",
  components: {
    ScientificInformationCardRow,
    ListWithArrows,
    ProductsForIntervention,
    AccordionVideoContainer,
  },
};
</script>

<style lang="scss">
@import "@/assets/scss";
.aspiration-section {
  display: flex;
  flex-direction: column;
  font-family: $font_nettoRegular;
  background-color: lightgray;
  background: -webkit-radial-gradient(circle center 50%, lightgray, gray);
  background: radial-gradient(circle at center 50%, lightgray, gray);
  align-items: center;
  cursor: default;
  padding-top: 1rem;
}
</style>
